// A v1 blueprint's payload is synthesized with BlueprintItem ids as envelope
// ids. Every save that sends a payload must request the one-way v2 conversion,
// or the API rejects it (applied as v2, those ids would be read as
// ProjectService ids).
export const conversionAttributes = (
  dataVersion?: string | null
): { "data-version"?: "v2" } =>
  dataVersion === "v1" ? { "data-version": "v2" } : {};
